module.exports = __webpack_public_path__ + "static/img/remote_work.0329b0bb.jpg";